module.exports = __webpack_public_path__ + "reviews.png?0109191e3232f9d33599c7373b5bdef6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reviews.png
// module id = 1003
// module chunks = 2